import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../util/ext";

const useStyles = makeStyles(theme => ({
  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },
}));

const RegionAuthenticationCell = props => {
  const { authentication } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      {notBlank(authentication.city) && (
        <Grid item sm={6}>
          <Box className={classes.labelAndValue}>
            <label>City:</label>
            {authentication.city}
          </Box>
        </Grid>
      )}

      {notBlank(authentication.county) && (
        <Grid item sm={6}>
          <Box className={classes.labelAndValue}>
            <label>County:</label>
            {authentication.county}
          </Box>
        </Grid>
      )}

      {notBlank(authentication.state) && (
        <Grid item sm={6}>
          <Box className={classes.labelAndValue}>
            <label>State:</label>
            {authentication.state}
          </Box>
        </Grid>
      )}

      {notBlank(authentication.country) && (
        <Grid item sm={6}>
          <Box className={classes.labelAndValue}>
            <label>Country:</label>
            {authentication.country}
          </Box>
        </Grid>
      )}

      {notBlank(authentication.dateExpires) && (
        <Grid item sm={6}>
          <Box className={classes.labelAndValue}>
            <label>Expires:</label>
            {authentication.dateExpires}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default RegionAuthenticationCell;
